/**
 * IAM 的 digi-middleware-auth-app [各應用系統的AppToken].
 */
// tslint:disable-next-line:max-line-length
export const DigiMiddlewareAuthApp = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE0OTY3OTkyODc1OTksInNpZCI6ODIyMDIzMzgxOTg0NjE5NjUxLCJpZCI6InNhbXBsZUFwcDEifQ.9LkXL8DX2VdIyTV8qGQCFXYmuCCmVTS_Niqd1O25VJI';
